import MicroModal from 'micromodal';

export class SMS {
    static isUserLoggedIn() {
        return CLWP_PC_GLOBAL.isLoggedIn;
    }

    static isUserOptedIn() {
        return Electro.SMSOptedIn;
    }

    static userHasPhoneMobile() {
        return Electro.HasPhoneMobile;
    }

    /**
     * This triggers a modal on any page.
     *
     * This can be used on the homepage popups, and on the recipe detail page.
     *
     * This does not run conditionals on should or should not trigger the modal. The conditionals should be run before calling this method.
     */
    static triggerModal() {
        sessionStorage.setItem('seenAttentiveForm', '1');

        let type = 'new_user_sms_opt_in';
        if ( document.getElementById('single-recipe') ) {
            type = 'recipe_sms_opt_in';
        } else if ( SMS.isUserLoggedIn() ) {
            type = 'existing_user_sms_opt_in';
        }

        // Show the modal
        MicroModal.show(`modal-${type}`, {
            closeTrigger: 'data-custom-close',
        });
    }

    static setSMSModalTimer() {
        setTimeout(() => {
            SMS.triggerModal();
        }, 10000);
    }
}
